import { lazy } from 'react';

const LazyFloatingAgent = lazy(() => import('./FloatingAgent'));

export default LazyFloatingAgent;